import { makeRequest } from 'utils/requestLogger';

export default (payload) =>
  makeRequest('put', `/api/roundtable_welcome_settings`, payload).then(
    (resp) => resp.data
  );



// WEBPACK FOOTER //
// ./src/app/services/account/updateWelcomeSettings.js